import { render, staticRenderFns } from "./PAWeeklySportsGoal.vue?vue&type=template&id=373b3df1&"
import script from "./PAWeeklySportsGoal.vue?vue&type=script&lang=js&"
export * from "./PAWeeklySportsGoal.vue?vue&type=script&lang=js&"
import style0 from "./PAWeeklySportsGoal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports